export const SET_FULL_DATA = "SET_FULL_DATA";
export const SET_MASTER_DATA = "SET_MASTER_DATA";
export const SET_PACKAGES_DATA = "SET_PACKAGES_DATA";

export const SET_SINGLECOSMETIC_DATA = "SET_SINGLECOSMETIC_DATA";

export const SET_CUSTOMER_PERSONAL_INFO = "SET_CUSTOMER_PERSONAL_INFO";

export const SET_CHECKOUT_TYPE = "SET_CHECKOUT_TYPE";

export const SET_SINGLETREAT_DATA = "SET_SINGLETREAT_DATA";

export const SET_SPA_URL = "SET_SPA_URL";

export const SET_SPA_NAME = "SET_SPA_NAME";

export const SET_USER_FAVS = "SET_USER_FAVS";

export const SET_USER_CART = "SET_USER_CART";

export const SET_SHOW_X = "SET_SHOW_X";

export const SET_TOKEN = "SET_TOKEN";

export const SET_TREATMENT_REVEAL = "SET_TREATMENT_REVEAL";

export const SET_LOCAL_PROPERTIES = "SET_LOCAL_PROPERTIES";

export const SET_ONSITE_RETURN_CART = "SET_ONSITE_RETURN_CART";
